import { put, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import { GetDashboardActionTypes } from './types';
import { getAccountActions } from '../account/actions';
import { getLatestTicketTransactionsActions } from '../ticket/actions';
import { getFaqNotificationsActions } from '../faq/actions';

export default function* appSaga() {
    yield takeEvery(GetDashboardActionTypes.REQUEST, getDashboardRequest);
}

function* getDashboardRequest(action: Action<undefined>) {
    yield put(getAccountActions.request());
    yield put(getLatestTicketTransactionsActions.request());
    yield put(getFaqNotificationsActions.request());
}